var _defs, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgOctopiMenu(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Octopi_Colors",
    "data-name": "Octopi Colors",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 45.389,
    height: 44.492,
    viewBox: "0 0 45.389 44.492",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 0.5,
    x2: 0.5,
    y2: 1,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#EFE51D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EFE51D"
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_123",
    "data-name": "Path 123",
    d: "M5540.6,4094.081s6.085-6.323,2.571-13.61-16.343-6.244-18.295,1.3,2.917,12.158,2.841,12.827,1.171-.651-2.6,1.561-7.417,4.555-11.451,1.171a2.637,2.637,0,0,0-.633-.542c-1.917-1.36,1.395,4.042,3.085,4.333s4.993.378,5.615-.407-4.858,6.628-9.255,3.87c-4.343-2.725,2.856,4.451,7.019,1.892h0c4.927-4.234,7.441-4.331,7.441-4.331s-2.342,7.547-11.711,6.9,4.373,1.859,6.506,1.74a11.241,11.241,0,0,0,7.157-3.953c.021-.078.039-.147.066-.265a11.808,11.808,0,0,0-.066,6.628c1.063,2.964,4.458,5.351,7.027,2.136l.307-.384c2.089-2.629-5.8,3.516-5.251-6.553,0-.007,0-.015,0-.01,3.051-6.094,2.469-3.243,2.469-3.243s.584,5.979,5.514,8.176l.067.029c4.987,2.13-2.7,5.825-3.108,6.368s4.188.656,5.726-2.342a5.179,5.179,0,0,0-.116-4.579,7.981,7.981,0,0,0-.393-.752,7.4,7.4,0,0,0-.531-.784l-.127-.14a34.637,34.637,0,0,1-2.589-3.157,5.7,5.7,0,0,1-.8-3.471s4.219,5.808,7.632,6.208a14.033,14.033,0,0,0,7.073-1.654c2.71-1.508-7.832,2.657-11.936-6.884l-.03-.011a31.3,31.3,0,0,1,3.6.771c1.85.523,4.006,4.172,7.064,4.563s5.205-2.993,5.205-2.993-4.995,2.2-6.9,0a42.861,42.861,0,0,0-6.5-5.267l.875.1s6.066,2.228,9.2,1.73a5.609,5.609,0,0,0,4.151-3.613s-4.623,3.519-7.722,1.324A73.581,73.581,0,0,0,5540.6,4094.081Z",
    transform: "translate(-5511.128 -4075.525)",
    fill: "url(#linear-gradient)"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgOctopiMenu);
export default __webpack_public_path__ + "static/media/octopi_menu.077f260c18657af2f89b796debebc91d.svg";
export { ForwardRef as ReactComponent };